import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { MbCartPoUploadComponent } from './mb-cart-po-upload.component'
import { RouterLink } from '@angular/router'
import { MbPaymentMethodsModule } from '../mb-payment-methods/mb-payment-methods.module'

@NgModule({
    imports: [
        ConfigModule.withConfig({
            cmsComponents: {
                MiltenyiCartPagePurchaseOrderUploadComponent: {
                    component: MbCartPoUploadComponent
                }
            }
        }),
        CommonModule,
        I18nModule,
        RouterLink,
        MbPaymentMethodsModule,
    ],
  providers: [],
  declarations: [MbCartPoUploadComponent]
})

export class MbCartPoUploadModule {
}
